import { message } from 'antd';

type RtkError = {
	data?: { detail?: unknown };
	status?: number | string;
	originalStatus?: number;
};

/** Pull a user-friendly error string out of an RTK Query error. The KT
 *  backend's move/delete endpoints return `{error, detail}` for 400/409;
 *  network failures show a generic note. */
export function explainMoveError(e: unknown, fallback: string): string {
	if (!e) return fallback;
	const err = e as RtkError;
	const detail = err?.data?.detail;
	if (typeof detail === 'string' && detail.length > 0) return detail;
	if (err?.status === 'FETCH_ERROR') return 'Network error — check your connection.';
	if (err?.status === 500 || err?.originalStatus === 500) {
		return 'Server error — try again in a moment, or contact support if it persists.';
	}
	if (err?.status === 409) {
		return typeof detail === 'string' && detail ? detail : 'Action conflicts with current state.';
	}
	if (err?.status === 403) return "You don't have permission for that action.";
	return fallback;
}

/** Show a 5-second error toast with a friendly explanation. */
export function showMoveError(e: unknown, fallback: string): void {
	message.error({ content: explainMoveError(e, fallback), duration: 5 });
}

/** Show a brief success toast. */
export function showMoveSuccess(text: string): void {
	message.success({ content: text, duration: 2 });
}
